import httpUtils from '../utils/http-utils';

const SERVICE_NAME = process.env.REACT_APP_API_ENDPOINT+"/user";

const login = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/login", payload);
}

const register = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/register", payload);
}

const edit = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/edit", payload);
}

const remove = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/delete", payload);
}

const search = (condition = {}, paginable = { rowPerPage: 999, currentPage: 1 }) => {
    return httpUtils.post(SERVICE_NAME + "/search", {condition, paginable});
}

const getById = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/getById", payload);
}

const resetPassword = (payload) => {
    return httpUtils.post(SERVICE_NAME + "/resetPassword", payload);
}


const userApi = {
    login,
    register,
    edit,
    remove,
    search,
    getById,
    resetPassword
}

export default userApi;